// extracted by mini-css-extract-plugin
export default {"component":"CopyButtonStyles_component__7argg","withTitle":"CopyButtonStyles_withTitle__59gkl","title":"CopyButtonStyles_title__1zMo8"};